import Vue from 'vue'
import { router } from '@router'
import store from '@state/store'
import App from './app.vue'

import _ from 'lodash'

// Styles
import '@design/index.scss'
import '@design/icons.scss'

// libs
import '@libs/events'
import '@libs/toastification'
import '@libs/sweet-alerts'
import '@libs/tel-input'
import '@libs/floating-vue'

// Globally register all `_base`-prefixed components
import '@components/_globals'

// global mixins
import * as mixins from '@mixins';

// register global utility mixins.
for (const key of Object.keys(mixins)) {
  Vue.mixin(mixins[key]);
}

// prototype
Vue.prototype.$_ = _

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
